/**
 * PositionStrip.jsx
 * 
 * Phase 2F5 - Extracted from GMRosterBuilderV2
 * Displays unit allocation breakdown by position as a horizontal bar.
 * 
 * BSL Compliant: Position colors only, no judgment colors.
 */

import React from 'react';
import { POSITION_COLORS } from './RosterSlot';

/**
 * @param {Object} props
 * @param {Array} props.roster - Roster array with player and units
 */
const PositionStrip = ({ roster }) => {
  const filled = roster.filter(s => s.player);
  const totalUnits = filled.reduce((s, r) => s + r.units, 0);
  
  if (totalUnits === 0) return null;
  
  // Aggregate units by position
  const posUnits = {};
  filled.forEach(s => { 
    posUnits[s.player.position] = (posUnits[s.player.position] || 0) + s.units; 
  });
  
  return (
    <div className="flex h-2.5 rounded-full overflow-hidden bg-slate-100">
      {Object.entries(posUnits).map(([pos, units]) => (
        <div 
          key={pos} 
          className="h-full transition-all" 
          style={{ 
            width: `${(units / totalUnits) * 100}%`, 
            backgroundColor: POSITION_COLORS[pos] 
          }} 
        />
      ))}
    </div>
  );
};

export default PositionStrip;
